// extracted by mini-css-extract-plugin
export default {"Outer":"FadeCollapse_Outer__Yy9kL","Visible":"FadeCollapse_Visible__inZM2"};